import { FC, useMemo } from 'react';

import { RoundWinnerOutcomes } from 'shared/constants/shared-enums';
import { useRoomStore } from 'shared/store/roomStore';
import { getMoveIcon } from 'shared/utils/getMoveIcon';
import { getMoveIconText } from 'shared/utils/getMoveIconText';

interface StreamMobileHistoryMoveProps {
  round: {
    moveA: number;
    moveB: number;
    winner: RoundWinnerOutcomes;
  };
  show?: boolean;
  index: number;
  totalVisible: number;
  isLast?: boolean;
}

export const StreamMobileHistoryMove: FC<StreamMobileHistoryMoveProps> = ({
  round,
  show,
  index,
  totalVisible,
  isLast,
}) => {
  const { amIPlayerA } = useRoomStore();

  const topIcon = useMemo(
    () => getMoveIcon(amIPlayerA ? round.moveB : round.moveA, 'w-4 scale-x-[-1] sm:w-8'),
    [round, amIPlayerA],
  );

  const bottomIcon = useMemo(
    () => getMoveIcon(amIPlayerA ? round.moveA : round.moveB, 'w-[22px] sm:w-12'),
    [round, amIPlayerA],
  );

  const isFaded = index !== totalVisible - 1;

  if (!show || !round.moveA || !round.moveB) {
    return null;
  }

  return (
    <div className="relative flex items-center">
      {isLast && <div className="mr-2 h-[54px] w-0.5 rounded-full bg-indigo sm:h-[108px]" />}
      <div
        className={`${
          round.winner === RoundWinnerOutcomes.Draw
            ? 'bg-[#1D213E]'
            : (round.winner === RoundWinnerOutcomes.PlayerB && amIPlayerA) ||
                (round.winner === RoundWinnerOutcomes.PlayerA && !amIPlayerA)
              ? 'bg-[#4F390D]'
              : 'bg-[#521732]'
        } relative flex h-[54px] w-10 shrink-0 flex-col items-center justify-between gap-px rounded-xl pt-px sm:h-[108px] sm:w-20 sm:pt-2 ${isFaded ? 'opacity-75' : 'opacity-100'}`}
      >
        {topIcon}
        <div
          className={` ${
            round.winner === RoundWinnerOutcomes.Draw
              ? 'border-[#323E96] bg-[#1D213E]'
              : (round.winner === RoundWinnerOutcomes.PlayerA && amIPlayerA) ||
                  (round.winner === RoundWinnerOutcomes.PlayerB && !amIPlayerA)
                ? 'border-[#FFC000] bg-[#89611C]'
                : 'border-[#E81C34] bg-[#7B3656]'
          } relative flex shrink-0 flex-col items-center justify-center gap-1 self-stretch rounded-xl border border-solid pb-1 pl-[9px] pr-[9px] pt-1`}
        >
          {bottomIcon}
          <div className="text-left text-[8px] font-semibold leading-[8px] text-white sm:text-md">
            {getMoveIconText(amIPlayerA ? round.moveA : round.moveB)}
          </div>
        </div>
      </div>
    </div>
  );
};
